import React = require('react');
import { get } from 'lodash';
import { ITraveller } from '../../../../../../data/api/models';

interface IHeaderDisplayProps {
  leadTraveller: ITraveller;
}

export const HeaderDisplay = ({ leadTraveller }: IHeaderDisplayProps) => {
  return (
    <div className={'page-header-container'}>
      <div className={'greeting'}>Hi {get(leadTraveller, 'firstName')}!</div>
      <div className={'title-section'}>
        <>
          <div>Unfortunately, we're unable</div>
          <div>to offer you Travel Insurance</div>
        </>
      </div>
      <div className={'text-container'}>
        <div className={'text-icon-container red'}>
          <img src={require('../../../../img/Plane.svg')} alt={'Admiral'}/>
        </div>
        <div className={'text-display-value'}>
          <>
            <div className={'text-display-info'}>This is at least partly due to the</div>
            <div className={'text-display-info'}>medical information provided.</div>
          </>
        </div>
      </div>
    </div>
  )
}
